export default __webpack_public_path__ + "static/media/am107.927bab67.png";